export default "__VITE_ASSET__r14SQGn___"